"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.testResults.title': 'Test Results',
    'botTest.testResults.results': 'results',
    'botTest.testResults.result': 'Result',
    'botTest.testResults.metrics': 'Metrics',
    'botTest.testResults.totalMessages': 'Total Messages',
    'botTest.testResults.totalTokens': 'Total Tokens',
    'botTest.testResults.totalCost': 'Total Cost',
    'botTest.testResults.executionTime': 'Execution Time',
    'botTest.testResults.averageResponseTime': 'Average Question Completion Time',
    'botTest.testResults.inputTokens': 'Input Tokens',
    'botTest.testResults.outputTokens': 'Output Tokens',
    'botTest.testResults.messageCount': 'Messages',
    'botTest.testResults.error': 'Error',
    'botTest.testResults.response': 'AI Response',
    'botTest.testResults.questionGeneration': 'Question Generation',
    'botTest.testResults.success': 'Success',
    'botTest.testResults.tokens': 'Tokens',
    'botTest.testResults.cost': 'Cost',
    'botTest.testResults.status.pending': 'Pending',
    'botTest.testResults.status.running': 'Running',
    'botTest.testResults.status.completed': 'Completed',
    'botTest.testResults.status.failed': 'Failed',
    'botTest.testResults.questionsAndAnswers': 'Questions & Answers',
    'botTest.testResults.question': 'Question',
    'botTest.testResults.questionLabel': 'Q',
    'botTest.testResults.answerLabel': 'A',
    'botTest.testResults.answerStartTime': 'Response Time (first token)',
    'botTest.testResults.no_results': 'No test results available',
    'botTest.testResults.no_results_description': 'Run the test to see results here.',
};
